/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type Methods = (typeof Methods)[keyof typeof Methods];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Methods = {
  CLASSIC: "CLASSIC",
  HYBRID: "HYBRID",
  AGILE: "AGILE",
} as const;
